import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Input from '@material-ui/core/Input';
import classNames from "classnames";
import { Grid } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typography from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import 'react-phone-input-2/lib/style.css'
import SocialComponent from '../../components/SocialComponent';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import { domainName, portal_config } from '../../../portal.config';
import { getAppCfg } from '../../utils/common';

const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const SuccessIcon = portalCfg.publicPath + "/icons/check.png";



const styles = theme => ({
    container: {
        paddingTop: theme.spacing(20),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    marginTop4x: {
        marginTop: theme.spacing(8),
    },
    formLogin: {
       
    },
    marginRight: {
        marginRight: theme.spacing(4)
     },
});
function LoginEmailView(props){
    const { classes, t, language, showAlert, onShowLoading, auth_support } = props;
    return (
        <PublicPage rightComponent={<LoginViewComponent classes={classes}
            t={t}
            onLogin={props.onLogin}
            showAlert={showAlert}
            onShowLoading={onShowLoading}
            auth_support={auth_support}
            onRegister = {props.onRegister}
        />} />
    );
}

function LoginViewComponent(props) {
    const { classes, t, showAlert, onShowLoading, auth_support } = props;
    return (
        <Grid xs={12} sm={12} md={12} item container>
            <Grid xs={12} sm={12} item container>
                <Typography variant='h2' color={portal_config[domainName].publicPagePrimaryColor?'onPrimary':'primary'} mg_bottom_md>{t('btn_login')}</Typography>
            </Grid>
            <Grid xs={12} item container direction="row">
                <Typography variant='body2' color={portal_config[domainName].publicPagePrimaryColor?'onPrimary':'primary'} center>{t('dont_have_account')}&nbsp;</Typography>
                <LinkRouter onClick = {props.onRegister} variant='body2' size='sm' color={portal_config[domainName].publicPagePrimaryColor?null:'primary'}>{t('btn_register')}</LinkRouter>
            </Grid>
            
            <Grid xs={12} sm={12} item container justify='center' className={classes.marginTop}>
                <LoginForm classes={classes} t={t}
                    onSubmit={props.onLogin}
                />
            </Grid>
            {(auth_support.facebook || auth_support.google) ? <SocialComponent showAlert={showAlert} onShowLoading={onShowLoading} auth_support={auth_support} /> : null}
        </Grid>

    )
}
function LoginForm(props) {
    const { classes, t, showAlert, onShowLoading } = props;
    const appConfig = getAppCfg()
    var isEmailOtp = appConfig && appConfig.auth_support && appConfig.auth_support.email_otp;
    return (
        <Form
            onSubmit={props.onSubmit}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item>
                    <Field
                        name="username"
                        component={TextFieldComponent}
                        label={t('email')}
                        placeholder={t('email_input_placeholder')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.validEmail)}
                        autoFocus={true}
                    />
                    {!isEmailOtp&&<Field
                        name="password"
                        component={TextFieldComponent}
                        label={t('password')}
                        placeholder={t('enter_your_password')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.required)}
                        autoFocus={true}
                        type='password'
                    />}
                    {!isEmailOtp&&<Grid xs={12} item container justify='flex-end' className={classes.marginRight}>
                        <LinkRouter to='forgot-password' color='primary' size='sm' >{t('forgot_password')}</LinkRouter>
                    </Grid>}
                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                        <Button color={portal_config[domainName].publicPagePrimaryColor?'dark':'primary'} fullWidth onClick={handleSubmit}>{t('btn_login')}</Button>
                    </Grid>
                </Grid>
            )} />
    )
}
export default withStyles(styles)(withTranslation()(LoginEmailView));